module.exports = __webpack_public_path__ + "static/media/SIG1.4eace00e.png";